import '@gov.wa.lni/application.warehouse-retaliation/source/styles/styles.scss';

import interactions from '@gov.wa.lni/application.warehouse-retaliation/source/interactions';
import components from '@gov.wa.lni/application.warehouse-retaliation/source/components';

import ApplicationMain from '@gov.wa.lni/application.warehouse-retaliation/source/application-main.vue';
import store from '@gov.wa.lni/application.warehouse-retaliation/source/store.js';

import HomePage from '@gov.wa.lni/application.warehouse-retaliation/source/pages/home.page.vue';
import ResultPage from '@gov.wa.lni/application.warehouse-retaliation/source/pages/second.page.vue';

const options = {
    addAccessibleRouting: true,
    components: {
        ApplicationMain,
    },
    applicationComponents: [
        ...components,
    ],
    applicationActions: interactions,
};

const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: HomePage,
        meta: {
            title: 'Warehouse Retaliation Complaint',
        },
    },
    {
        path: '/confirmation',
        name: 'SecondPage',
        component: ResultPage,
        meta: {
            title: 'Confirmation',
        },
    },
];

options.routing = {
    navigationGuards: {
        beforeEach: (store, to, from, next) => {
            if (to.path === '/' || to.path === '/confirmation') {
                next();
                return;
            }

            const isInitialized = !!store.state.appState?.isInitialized;
            const hasFormData = !!store.state.appState?.hasFormData;
            if (!isInitialized || !hasFormData) {
                next('/');
                return;
            }
            store.commit('appState/SET_VALUE', {
                key: 'isLoading',
                value: true,
            });
            next();
        },
    },
    routes,
};

window.lni.oneLniCorePlugin.initialize(
    options,
    configuration => {
        window.lni.Vue.use(window.lni.oneLniCorePlugin);
        const application = new window.lni.Vue(configuration);
        window.lni.oneLniCorePlugin.setApplication(application);
        application.$store.registerModule('appState', store);
    });